export { formatDistance, formatPace } from '@trainme/api/client';

// deprecated, only use for backwards compatibility. now lap should have averagePace without this function
export const speedToPace = (speed: number | null): number | null => {
  if (speed === null || speed === undefined) {
    return null;
  }
  const paceInSecondsPerKilometer = 1000 / speed; // Convert m/s to s/km
  return paceInSecondsPerKilometer;
};

export const metersToKilometers = (
  meters: number | null,
  precision: number = 2
): number | null => {
  if (meters === null || meters === undefined) {
    return null;
  }
  const factor = 10 ** precision;
  return Math.round((meters / 1000) * factor) / factor;
};
